import { Font } from 'three/addons/loaders/FontLoader.js';
import { TTFLoader } from 'three/addons/loaders/TTFLoader.js';

class FontProvider {
    private static instance: FontProvider = new FontProvider();
    arial?: Font = undefined;
    isInitialized: boolean = false;

    private constructor() {}

    static async getInstance() {
        if (!FontProvider.instance.isInitialized) {
            await FontProvider.instance.initialize();
        }
        return FontProvider.instance;
    }

    static getInstanceSync() {
        if (!FontProvider.instance.isInitialized) {
            throw new Error("FontProvider is not initialized. Please call getInstance() first.");
        }
        return FontProvider.instance;
    }

    private async initialize() {
        if (this.isInitialized) {
            return;
        }

        const loader = new TTFLoader();
        const json = await loader.loadAsync('/fonts/arial.ttf'); 
        this.arial = new Font(json);
        this.isInitialized = true;
        return true;
    }


}

export default FontProvider;